export default __webpack_public_path__ + "static/media/bullet.690e68fb.svg";